@if (isMobile()) {
  <div class="task-details-mobile flex w-full flex-col gap-2">
    <div class="flex w-full items-center gap-2">
      <button
        (click)="closeRequested.emit()"
        [attr.aria-label]="'task-details-panel.close' | translate"
        type="button"
        class="task-details-icon-button proffeo-ui-focus-ring"
      >
        <mat-icon fontIcon="arrow_back" class="icon-md" />
      </button>
      <proffeo-task-type-select
        (taskTypeSelected)="taskTypeSelected.emit($event)"
        [readonly]="false"
        [taskTypes]="taskTypes()"
        [activeTaskType]="task().taskType()"
        [taskNumber]="task().taskNumber"
        class="min-w-0 flex-1"
      />
      <proffeo-task-details-view-settings />
      <button
        [matMenuTriggerFor]="taskActionsMenu()"
        [attr.aria-label]="'project-tasks.list.task.open-actions' | translate"
        type="button"
        class="task-details-icon-button proffeo-ui-focus-ring"
      >
        <mat-icon
          fontIcon="more_vert"
          class="icon-md"
        />
      </button>
    </div>
    <div class="w-full min-w-0">
      @if (isNameEditing()) {
        <proffeo-ui-textarea-editor
          (saved)="taskNameChanged.emit($event)"
          (cancelled)="nameEditCancelled.emit()"
          [value]="task().name"
          [maxLength]="maxTaskNameLength()"
          class="w-full task-name-editor"
        />
      } @else {
        <h1
          (click)="nameEditRequested.emit()"
          class="task-details-header-title task-details-header-title--emphasis w-full cursor-pointer break-words text-xl"
        >
          {{ task().name }}
        </h1>
      }
    </div>
  </div>
} @else if (desktopSection() === 'identity') {
  <proffeo-task-type-select
    (taskTypeSelected)="taskTypeSelected.emit($event)"
    [readonly]="false"
    [taskTypes]="taskTypes()"
    [activeTaskType]="task().taskType()"
    [taskNumber]="task().taskNumber"
    class="min-w-0 flex-shrink-0"
  />
} @else {
  @if (isNameEditing()) {
    <proffeo-ui-textarea-editor
      (saved)="taskNameChanged.emit($event)"
      (cancelled)="nameEditCancelled.emit()"
      [value]="task().name"
      [maxLength]="maxTaskNameLength()"
      class="p-1 w-full task-name-editor"
    />
  } @else {
    <h1
      (click)="nameEditRequested.emit()"
      class="p-1 task-details-header-title w-full break-words text-xl cursor-pointer font-normal"
    >
      {{ task().name }}
    </h1>
  }
}
